import { useQuery } from '@tanstack/react-query';
import { livestreamViewerApi } from '../../event_dashboard/api/livestreamViewerApi';
import type { LivestreamViewer } from '../../event_dashboard/types/livestream.types';

export const useLivestreamViewer = (eventSlug: string, livestreamId?: string) => {
  return useQuery<LivestreamViewer>({
    queryKey: ['livestreamViewer', eventSlug, livestreamId],
    queryFn: () => livestreamViewerApi.getLivestreamViewer(eventSlug, livestreamId!),
    enabled: !!eventSlug && !!livestreamId,
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: (data) => {
      // Refetch more frequently if livestream is upcoming or live
      if (data?.status === 'LIVE' || data?.status === 'UPCOMING') {
        return 30 * 1000; // 30 seconds
      }
      return false; // Don't refetch for past streams
    }
  });
};